export const initialAuth = {
  token: '',
  profile: null,
  isLoading: false,
  isRefreshing: false,
  error: '',
};
